import useSWRFetcher from "../commonly-stored/fetcher";
import useSWR from "swr";
import settings from "../../../constants/settings";
import { useCallback } from "react";
import { InventoryItemsResponse } from "./getInventoryItems";

export default function useGetStencilsForProject(boardId: string) {
  const fetcher = useSWRFetcher<InventoryItemsResponse>();

  const { data, mutate } = useSWR<InventoryItemsResponse>(
    `${settings.api_url}/boards/${boardId}/stencils`,
    fetcher,
  );

  const refreshStencilsForProject = useCallback(() => {
    void mutate();
  }, [mutate]);

  return {
    stencilsForProject: data || null,
    refreshStencilsForProject,
  };
}
